import React, { useState } from 'react';
import './GiveawayCreatePanel.css';
import { giveawaysAPI } from '../utils/api';

function GiveawayCreatePanel({ currentUser, onClose, onCreated }) {
  const [formData, setFormData] = useState({
    title: '',
    prize: '',
    description: '',
    daysUntilEnd: 7,
    maxEntries: 1
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (currentUser?.role !== 'founder') {
      setError('Only the Founder can create giveaways.');
      setLoading(false);
      return;
    }

    try {
      const endsAt = new Date(Date.now() + formData.daysUntilEnd * 24 * 60 * 60 * 1000).toISOString();
      const newGiveaway = await giveawaysAPI.create({
        title: formData.title,
        prize: formData.prize,
        description: formData.description,
        endsAt,
        prizeValue: 0,
      });

      alert(`Giveaway "${formData.title}" created successfully!`);
      if (onCreated) {
        onCreated();
      }
      onClose();
    } catch (err) {
      setError(err.message || 'Failed to create giveaway');
    } finally {
      setLoading(false);
    }
  };

  if (currentUser?.role !== 'founder') {
    return (
      <div className="create-panel-overlay" onClick={onClose}>
        <div className="create-panel" onClick={(e) => e.stopPropagation()}>
          <div className="create-panel-header">
            <h2>Create Giveaway</h2>
            <button className="close-btn" onClick={onClose}>×</button>
          </div>
          <div className="access-denied">
            <p>Only the Founder can create giveaways.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="create-panel-overlay" onClick={onClose}>
      <div className="create-panel" onClick={(e) => e.stopPropagation()}>
        <div className="create-panel-header">
          <h2>🎁 Create New Giveaway</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <form className="create-panel-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="title">Giveaway Title *</label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="e.g. Discord Nitro Monthly"
              required
              maxLength="100"
            />
          </div>

          <div className="form-group">
            <label htmlFor="prize">Prize *</label>
            <input
              type="text"
              id="prize"
              name="prize"
              value={formData.prize}
              onChange={handleChange}
              placeholder="e.g. Discord Nitro Classic (1 Month)"
              required
              maxLength="200"
            />
          </div>

          <div className="form-group">
            <label htmlFor="description">Description *</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Describe the giveaway..."
              required
              rows="4"
              maxLength="500"
            />
            <small>{formData.description.length}/500 characters</small>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="daysUntilEnd">Duration (days) *</label>
              <input
                type="number"
                id="daysUntilEnd"
                name="daysUntilEnd"
                value={formData.daysUntilEnd}
                onChange={handleChange}
                min="1"
                max="365"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="maxEntries">Max Entries Per User *</label>
              <input
                type="number"
                id="maxEntries"
                name="maxEntries"
                value={formData.maxEntries}
                onChange={handleChange}
                min="1"
                max="10"
                required
              />
            </div>
          </div>

          <div className="create-panel-actions">
            <button type="submit" className="create-btn">
              Create Giveaway
            </button>
            <button type="button" className="cancel-btn" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default GiveawayCreatePanel;

